import { jsx as _jsx } from "react/jsx-runtime";
import { useReducer } from 'react';
import { defaultProgrammeReducerState, EntityProgrammeContext, getProgrammeReducer } from './Reducers/ProgrammeReducer';
import { EntityProgrammeInternal } from './EntityProgrammeInternal';
export const EntityProgrammeBase = (props) => {
    const reducer = getProgrammeReducer();
    const [state, dispatch] = useReducer(reducer, defaultProgrammeReducerState);
    return (_jsx(EntityProgrammeContext.Provider, { value: [state, dispatch], children: _jsx(EntityProgrammeInternal, { ...props }) }));
};
